import { IVectorCoordinatableObject } from "../../../../../../domain/editableFormat/objects";
import { IVectorCoordinatableObjectBean } from "../../../beans/objects";
import { AbstractObjectTranslator } from "../AbstractObjectTranslator";
import { ObjectTranslator } from "./ObjectTranslator";

export class VectorCoordinatableObjectTranslator<TObject extends IVectorCoordinatableObject, TBean extends IVectorCoordinatableObjectBean> extends AbstractObjectTranslator<TObject, TBean> {
  constructor() {
    super(new ObjectTranslator());
  }

  overwriteObject(source: TObject, bean: TBean, formatId: number): void {
    source.vector = {
      from: {
        x: this.integer.from(bean["@startx"]),
        y: this.integer.from(bean["@starty"]),
      },
      to: {
        x: this.integer.from(bean["@endx"]),
        y: this.integer.from(bean["@endy"]),
      },
    };
  }

  overwriteBean(source: TBean, object: TObject): void {
    source["@startx"] = this.integer.to(object.vector.from.x);
    source["@starty"] = this.integer.to(object.vector.from.y);
    source["@endx"] = this.integer.to(object.vector.to.x);
    source["@endy"] = this.integer.to(object.vector.to.y);
  }
}
